export type PresentationLanguage = 'pt' | 'en';

const STYLE_LABELS: Record<string, { pt: string; en: string }> = {
  Aventura: { pt: 'Aventura', en: 'Adventure' },
  Luxo: { pt: 'Luxo', en: 'Luxury' },
  Cultural: { pt: 'Cultural', en: 'Cultural' },
  Gastronomia: { pt: 'Gastronomia', en: 'Food & Dining' },
  Relaxamento: { pt: 'Relaxamento', en: 'Relaxation' },
  Família: { pt: 'Família', en: 'Family' },
  'Lua de Mel': { pt: 'Lua de Mel', en: 'Honeymoon' },
  Executivo: { pt: 'Executivo', en: 'Executive' },
  Cruzeiro: { pt: 'Cruzeiro', en: 'Cruise' },
};

const REGION_LABELS: Record<string, { pt: string; en: string }> = {
  Europa: { pt: 'Europa', en: 'Europe' },
  'América do Norte': { pt: 'América do Norte', en: 'North America' },
  'América do Sul': { pt: 'América do Sul', en: 'South America' },
  Ásia: { pt: 'Ásia', en: 'Asia' },
  África: { pt: 'África', en: 'Africa' },
  Oceania: { pt: 'Oceania', en: 'Oceania' },
  'Oriente Médio': { pt: 'Oriente Médio', en: 'Middle East' },
  Caribe: { pt: 'Caribe', en: 'Caribbean' },
};

const COUNTRY_LABELS: Record<string, { pt: string; en: string }> = {
  Brasil: { pt: 'Brasil', en: 'Brazil' },
  Colômbia: { pt: 'Colômbia', en: 'Colombia' },
  Aruba: { pt: 'Aruba', en: 'Aruba' },
  México: { pt: 'México', en: 'Mexico' },
  Tailândia: { pt: 'Tailândia', en: 'Thailand' },
  Laos: { pt: 'Laos', en: 'Laos' },
  Japão: { pt: 'Japão', en: 'Japan' },
  'Oceano Índico': { pt: 'Oceano Índico', en: 'Indian Ocean' },
  Omã: { pt: 'Omã', en: 'Oman' },
  Turquia: { pt: 'Turquia', en: 'Turkey' },
  Jordânia: { pt: 'Jordânia', en: 'Jordan' },
  'Emirados Árabes': { pt: 'Emirados Árabes', en: 'United Arab Emirates' },
  'Emirados Árabes Unidos': { pt: 'Emirados Árabes Unidos', en: 'United Arab Emirates' },
  França: { pt: 'França', en: 'France' },
  'Estados Unidos': { pt: 'Estados Unidos', en: 'United States' },
  Itália: { pt: 'Itália', en: 'Italy' },
  Espanha: { pt: 'Espanha', en: 'Spain' },
  Portugal: { pt: 'Portugal', en: 'Portugal' },
};

const RHYTHM_LABELS: Record<string, { pt: string; en: string }> = {
  relaxado: { pt: 'Relaxado', en: 'Relaxed' },
  equilibrado: { pt: 'Equilibrado', en: 'Balanced' },
  intenso: { pt: 'Intenso', en: 'Intense' },
};

const MUST_HAVE_LABELS: Record<string, { pt: string; en: string }> = {
  gastronomia: { pt: 'Gastronomia', en: 'Food & dining' },
  cultura: { pt: 'Cultura e história', en: 'Culture & history' },
  natureza: { pt: 'Natureza e paisagens', en: 'Nature & landscapes' },
  aventura: { pt: 'Aventura e esportes', en: 'Adventure & sports' },
  vida_noturna: { pt: 'Vida noturna', en: 'Nightlife' },
  compras: { pt: 'Compras', en: 'Shopping' },
  relaxamento: { pt: 'Relaxamento e bem-estar', en: 'Relaxation & wellness' },
  fotografia: { pt: 'Fotografia e mirantes', en: 'Photography & viewpoints' },
  arte: { pt: 'Arte e design', en: 'Art & design' },
  espiritualidade: { pt: 'Espiritualidade', en: 'Spirituality' },
  interacao_local: { pt: 'Interação local', en: 'Local interaction' },
  vinhos: { pt: 'Vinhos e degustações', en: 'Wine & tastings' },
};

function labelFor(
  labels: Record<string, { pt: string; en: string }>,
  value: string,
  language: PresentationLanguage,
): string {
  return labels[value]?.[language] ?? value;
}

export const getTravelStyleLabel = (value: string, language: PresentationLanguage) =>
  labelFor(STYLE_LABELS, value, language);

export const getRegionLabel = (value: string, language: PresentationLanguage) =>
  labelFor(REGION_LABELS, value, language);

export const getCountryLabel = (value: string, language: PresentationLanguage) =>
  labelFor(COUNTRY_LABELS, value, language);

export const getRhythmLabel = (value: string, language: PresentationLanguage) =>
  labelFor(RHYTHM_LABELS, value, language);

export const getMustHaveLabel = (value: string, language: PresentationLanguage) =>
  labelFor(MUST_HAVE_LABELS, value, language);
